import type { FaireProductEntity } from "../../entity_types/product";

export const p_6xvem3urue: FaireProductEntity = {
  token: "p_6xvem3urue",
  type: "product",
  name: "Ethnic Retro Crochet Rainbow Cardigan",
  brandToken: "b_m4nc6munyv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5d1d4ca2ad0b7a03859285fe4494862d2ba24b7e2e0e49d376e026fc3c6c13dd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe0b9e4cdf0029cfc3e9a79a6afee29b6d7580d72d59f1ebd178b49c90b668cb.jpeg",
    "https://cdn.faire.com/fastly/7fccacdb5fab8d7174e5b7e53623057a22ad278296c30a4871498d3b6caa622d.jpeg",
    "https://cdn.faire.com/fastly/e048c0cd17d88a1447c965f9a2037fbb31cb5aa4b59efca704d7c5155cef71d1.jpeg",
    "https://cdn.faire.com/fastly/9ea11b3f853804b10237ad7e7ee72d4711bec9e688aae52abef0c0e0b509f7f2.jpeg",
    "https://cdn.faire.com/fastly/d42f105f14ded4bdbd077894d80db2312e2dbe06598871161f6e01b44296f88c.jpeg",
    "https://cdn.faire.com/fastly/c3aa2ac849ae4b8bb8a36589d7febb0a1846f8c729be06cf2cc5a19a446bbe3d.jpeg",
  ],
  priceDollars: 29.4,
  description:
    "ETHNIC RETRO CROCHET RAINBOW CARDIGAN_RCJW06095\n\nSize Chart(Inch)\t\t\t\n\tChest\tLength\tSleeve\nS\t 40.94 \t 21.65 \t 21.26 \nM\t 42.52 \t 22.05 \t 21.65 \nL\t 45.67 \t 22.44 \t 22.05 \n\nWomen shackets,crochet cardigan,cable knit sweater,ruffle dress,blouse,puff sleeve top,denim skirts,fall top,fall dress,blazer，Knit cardigan,Midi dress,Laple Shirts,Tank Top,Knit Top,High waist pants,Button down Jacket,Skirt,Ruffle blouse,Sweatshirt,hoodie,midi dress,knit sweater,2 piece set,denim jacket,plaid shirt,zip up jacket,wide leg pant,fur coat，tweed jacket,2026 Women Apparel",
  tags: [],
  msrpDollars: 58.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:34.080Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
